import { css as _css } from "emotion";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class;
import React, { PureComponent, lazy, Suspense } from 'react';
import { hot } from 'react-hot-loader';
import { withRouter } from 'react-router-dom';
import * as tiktok from '@bridge/tiktok';
import * as sharee from '@bridge/sharee';
import { Global, css } from '@emotion/core';
import sanitizeHtml from 'sanitize-html';
import styled from '@emotion/styled';
import md5 from 'md5';
import { Helmet } from 'react-helmet';
import AES from 'crypto-js/aes';
import ENC from 'crypto-js/enc-utf8';
import isEqual from 'lodash/isEqual';
import { CaseUtil, HTMLDecode, getUrlParams } from '@/utilities/common';
import { questionFilter, typeChecker } from './utilities/quest';
import { errorBounder } from '@/components/ErrorBoundary';
import { Provider } from '@/store';
import { traceOnError, tracePageOpen, traceShowQuestion, traceUpdateQuestion, traceExitQuestionnaire, traceSubmitQuestionnaire } from './tracer';
import { getLocalText, navigatorLang } from './utilities/language';
import { postMessage } from './utilities/postMessage';
import { getPage, scrollToTop, filterNonAnswer, handleLimitTime, getPageContentLogic, retrieveDataAfterSubmit, transferDefaultDataToQuest, sampleDataToQuestions, getRealQuestions, shuffleGroup } from './utilities/pageLogic';
import { allowedTags, allowedAttributes, showErrorQuestIds, getNewH5HTML, getCustomizedHTML, getCustomizedHTMLByQuestBgColor, languageOpts } from './constant';
import { GlbStyleBox } from './glbStyle';
import IconFont from '@/components/common/IconFont';
var Language = lazy(function () {
  return import('@/components/common/Language');
});
var Progress = lazy(function () {
  return import('@/components/Progress');
});
var Ending = lazy(function () {
  return import('@/components/Ending');
});
var NewEnding = lazy(function () {
  return import('@/components/NewEnding');
});
import * as api from '@/services/api';
import themesRepo from './theme';
import './index.less';
var CIPHER_TAG = 'data_bp_survey';
var pathname = window.location.pathname.replace(/\/$/, '');
var url = window.location.href;
var isUrlToGenStamp = /^\/q\//.test(pathname) && /bytedance|127.0.0.1/.test(url) && !/preview/.test(url) && url.includes(CIPHER_TAG);
var isUrlToDecrypt = /bytedance|127.0.0.1/.test(url) && !/preview/.test(url) && /^\/b\//.test(pathname);
sanitizeHtml.defaults.allowedTags = sanitizeHtml.defaults.allowedTags.concat(allowedTags);
sanitizeHtml.defaults.allowedAttributes = allowedAttributes;

// eslint-disable-next-line
String.prototype.html2Text = function () {
  return HTMLDecode(this.replace(/<.*?>/g, '').replace(/<\/.*?>/g, ''));
};

// eslint-disable-next-line
Window.prototype.setItem = function (key, value) {
  if (key === 'survey-quest-theme') {
    var newStorageEvent = document.createEvent('StorageEvent');
    try {
      var storage = {
        setItem: function setItem(k, val) {
          sessionStorage.setItem(k, val);
          newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
          window.dispatchEvent(newStorageEvent);
        }
      };
      return storage.setItem(key, value);
    } catch (error) {
      console.error('error: ', error.message);
    }
  }
};
var delay = function delay(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
};
var _ref10 = "video{";
var _ref11 = "}.matrix-line video{max-width:70vw;object-fit:fill;}";
var App = withRouter(_class = errorBounder(_class = /*#__PURE__*/function (_PureComponent) {
  _inherits(App, _PureComponent);
  function App(props) {
    var _this;
    _classCallCheck(this, App);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(App).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "submitting", false);
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "submitted", false);
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_resetStoreFirstCall", true);
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resetStore", function (id, quest) {
      window.allQuestions = _toConsumableArray(quest.questions);
      var _this$state = _this.state,
        answers = _this$state.answers,
        resume = _this$state.resume;
      var recycleUid = quest.recycleUid,
        recycleProducts = quest.recycleProducts,
        sampleConfig = quest.sampleConfig;
      var _questionFilter = questionFilter(quest.questions, answers, sampleConfig),
        _questionFilter$visib = _questionFilter.visibles,
        visibles = _questionFilter$visib === void 0 ? [] : _questionFilter$visib,
        isNextEnd = _questionFilter.isNextEnd,
        globalSampleGids = _questionFilter.globalSampleGids;
      var questions = visibles;
      if (Object.keys(globalSampleGids).length && shuffleGroup({
        sampleConfig: sampleConfig
      })) {
        questions = getRealQuestions({
          globalSampleGids: globalSampleGids,
          questions: questions
        });
      }
      var nextState = {
        id: id,
        msg: null,
        loading: false,
        quest: quest,
        questions: questions,
        allQuestions: _toConsumableArray(quest.questions),
        recycleUid: recycleUid,
        recycleProducts: recycleProducts,
        resume: resume,
        isNextEnd: isNextEnd
      };
      // 只有在测试环境下，resetStore才会调用多次。因此埋点写在里面
      if (_this._resetStoreFirstCall) {
        // 发送页面打开埋点
        tracePageOpen(quest.title);
        var total = questions.filter(function (el, index) {
          return typeChecker.isPageBreak(el) && index !== questions.length - 1;
        }).length;
        nextState.page = {
          total: total,
          current: 1
        };
        // eslint-disable-next-line no-unused-expressions
        nextState.answers;
        var _answers = {};
        try {
          if (isUrlToDecrypt) {
            var cipherAns = AES.decrypt(window.location.href.split('#/')[1], _this.questId);
            _answers = JSON.parse(cipherAns.toString(ENC));
          } else if (resume) {
            var urlParams = getUrlParams();
            var questId = window.isLocal && !(urlParams.uid || urlParams.uindex) ? "survey-preview-".concat(urlParams.id) : id;
            var LSAnswer = questId ? localStorage.getItem(questId) || '{}' : '{}';
            _answers = JSON.parse(LSAnswer);
          }
        } catch (error) {
          console.error(error.message);
        }
        nextState.answers = _answers;

        // if (!/LarkLocale/.test(navigator.userAgent) && !window.isReport) {
        //   const sso = document.cookie
        //     .match(/(?:door_username=)(.*)(?=;)/)?.[1]
        //     .split(';')[0];
        //   if (sso && gwm) {
        //     // eslint-disable-next-line no-undef
        //     gwm.creation({
        //       txt: sso,
        //       color: '#626262',
        //       css: {
        //         fontFamily:
        //           'BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue"',
        //       },
        //     });
        //   }
        // }
        _this._resetStoreFirstCall = false;
        var sum = quest.questions.filter(function (q) {
          return !typeChecker.isPageBreak(q);
        }).length;
        traceShowQuestion(sum);
      }
      _this.setState(nextState, _this.forceUpdate);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getQuestId", function () {
      if (pathname === '/') return;
      var ret = pathname.split('/'); // pathname一般都是 '/iGHria' 或 '/q/10666/DS4ut1N2/12c5/'
      if (!ret) return null;
      var id;
      if (ret[1] === 'q' || ret[1] === 'b') {
        _this.questId = ret[2]; // 问卷id
        id = ret[3]; // 问卷hash id
        _this.sign = ret[4]; // 签名
      } else {
        id = ret[1] || '';
      }
      return id.includes('preview') ? null : id;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOriginOrder", function (id) {
      if (!id) return -1;
      return (_this.state.quest.questions || []).filter(function (q) {
        return !typeChecker.isPageBreak(q);
      }).findIndex(function (q) {
        return q.id === id;
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "traceUpdate", function (id, selectedAnswers) {
      var order = _this.getOriginOrder(id);
      var type = _this.state.answers[id] === undefined ? 0 : 1;
      traceUpdateQuestion(type, order, id, selectedAnswers);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "retrieveDefaultAnswers", function (resume) {
      var hashId = _this.getQuestId();
      if (resume && hashId || window.isLocal) {
        var answers = {};
        try {
          var urlParams = getUrlParams();
          var questId = window.isLocal && !(urlParams.uid || urlParams.uindex) ? "survey-preview-".concat(urlParams.id) : hashId;
          var LSAnswer = questId ? localStorage.getItem(questId) || '{}' : '{}';
          answers = JSON.parse(LSAnswer);
        } catch (error) {
          console.error('get LSAnswer error: ', error.message);
        }
        _this.setState({
          answers: answers
        });
      }
      _this.setState({
        resume: resume
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "submitForm", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$state2, id, questions, showAnswer, recycleUid, recycleProducts, _this$state2$quest, prompt, hideAnalysisHeader, multiLanguage, originAnswers, qnVersion, answers, res, location, server_time, cost, rnd, _languageOpts$find, ua, appInfo, userInfo, apiParam, _userInfo;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this.submitting) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _this.submitting = true;
              _context2.next = 5;
              return delay(500);
            case 5:
              _this$state2 = _this.state, id = _this$state2.id, questions = _this$state2.questions, showAnswer = _this$state2.showAnswer, recycleUid = _this$state2.recycleUid, recycleProducts = _this$state2.recycleProducts, _this$state2$quest = _this$state2.quest, prompt = _this$state2$quest.prompt, hideAnalysisHeader = _this$state2$quest.hideAnalysisHeader, multiLanguage = _this$state2$quest.multiLanguage, originAnswers = _this$state2.answers, qnVersion = _this$state2.qnVersion;
              answers = filterNonAnswer(showAnswer, originAnswers, questions);
              _this.realPrompt = prompt;
              res = {};
              location = _this.props.location;
              answers.custom_answer = getUrlParams(location);
              answers.cost = +((Date.now() - _this.state.startTime) / 1000).toFixed(3);
              server_time = answers.server_time, cost = answers.cost, rnd = answers.rnd;
              answers.sign = md5("".concat(server_time).concat(cost).concat(rnd));
              answers.qn_version = qnVersion;
              if (multiLanguage) {
                answers.language = (_languageOpts$find = languageOpts.find(function (l) {
                  return l.value === window.language;
                })) === null || _languageOpts$find === void 0 ? void 0 : _languageOpts$find.cnLabel;
                answers.language_value = window.language;
              }
              ua = window.navigator.userAgent;
              if (!(/trill/i.test(ua) || /musical_ly/i.test(ua))) {
                _context2.next = 39;
                break;
              }
              _context2.prev = 18;
              _context2.next = 21;
              return tiktok.app.getAppInfo({});
            case 21:
              appInfo = _context2.sent;
              _context2.next = 24;
              return tiktok.app.getUserInfo({});
            case 24:
              userInfo = _context2.sent;
              _context2.next = 27;
              return tiktok.app.apiParam({});
            case 27:
              apiParam = _context2.sent;
              answers.uid = userInfo.user_id || appInfo.user_id || '';
              answers.did = apiParam.device_id || appInfo.device_id || '';
              _context2.next = 37;
              break;
            case 32:
              _context2.prev = 32;
              _context2.t0 = _context2["catch"](18);
              answers.uid = '';
              answers.did = '';
              console.error('get tiktok app info error', _context2.t0);
            case 37:
              _context2.next = 52;
              break;
            case 39:
              if (!/Lemon8/.test(ua)) {
                _context2.next = 52;
                break;
              }
              _context2.prev = 40;
              _context2.next = 43;
              return sharee.app.getUserInfo({});
            case 43:
              _userInfo = _context2.sent;
              answers.uid = _userInfo.user_id || '';
              answers.did = _userInfo.device_id || '';
              _context2.next = 52;
              break;
            case 48:
              _context2.prev = 48;
              _context2.t1 = _context2["catch"](40);
              answers.uid = '';
              answers.did = '';
            case 52:
              if (!id) {
                _context2.next = 56;
                break;
              }
              console.warn('提交 answers', answers);
              // 点击提交msg
              postMessage({
                type: 'pre-submit',
                answers: answers
              });
              return _context2.abrupt("return", api.submitQuest(id, answers, _this.questId, _this.sign, hideAnalysisHeader).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var result,
                  _result$data,
                  data,
                  _args = arguments;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        result = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                        if (window.limitTimeTask) {
                          clearTimeout(window.limitTimeTask);
                        }
                        _result$data = result.data, data = _result$data === void 0 ? {} : _result$data;
                        res = data;
                        traceSubmitQuestionnaire(true);
                        if (!res) {
                          res = {};
                        }
                        _this.submitting = false;
                        _this.submitted = true;
                        if (res.prompt) {
                          _this.realPrompt = res.prompt;
                        }
                        if (result && result.code === 200) {
                          // 提交成功msg
                          postMessage({
                            type: 'success-submit',
                            answers: answers,
                            result: result
                          });
                        }
                        _this.doAfterSubmit(result, answers);
                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              }))).catch(function (err) {
                // 提交失败msg
                postMessage({
                  type: 'error-submit',
                  code: err.code,
                  message: err.message
                });
                _this.doAfterSubmit({
                  code: err.code || 0,
                  i18n_prompt: err.i18n_prompt,
                  message: err.message
                }, answers);
                traceOnError(err.message, err.code, '提交接口');
                throw err;
              }));
            case 56:
              // lackof id ,we must be preview mode.
              console.warn('本地 answers', JSON.parse(JSON.stringify(answers)));
              _context2.next = 59;
              return new Promise(function (resolve) {
                return window.setTimeout(function () {
                  return resolve();
                }, 2000);
              });
            case 59:
              postMessage({
                type: 'error-submit',
                code: 0,
                message: '找不到问卷ID'
              });
              _this.doAfterSubmit(undefined, answers);
            case 61:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[18, 32], [40, 48]]);
    })));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "doAfterSubmit", function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var answers = arguments.length > 1 ? arguments[1] : undefined;
      var _this$state3 = _this.state,
        quest = _this$state3.quest,
        showLottery = _this$state3.showLottery;
      var finishImgUrl = quest.finishImgUrl,
        finishImgScale = quest.finishImgScale,
        did = quest.did,
        uid = quest.uid;
      _this.submitting = false;
      postMessage({
        type: 'did-submit',
        answers: answers,
        result: res
      });
      var retrieved = retrieveDataAfterSubmit({
        res: res,
        showQuotaLimit: _this.showQuotaLimit,
        id: _this.state.id,
        location: _this.props.location
      });
      if (retrieved) {
        var data = retrieved.data,
          score = retrieved.score,
          type = retrieved.type;
        var title = retrieved.title;
        if (score !== undefined) {
          var fixedScore = score;
          if (fixedScore !== Math.round(fixedScore)) {
            fixedScore = fixedScore.toFixed(2);
          }
          title = React.createElement(React.Fragment, null, React.createElement("div", {
            className: "flex alignCenter justifyCenter"
          }, title), React.createElement("div", {
            className: "flex alignCenter justifyCenter"
          }, getLocalText('user-score'), React.createElement("div", {
            className: "score"
          }, fixedScore)));
        }
        _this.setState({
          quest: _objectSpread({}, quest, {
            showProgress: false
          }),
          msg: {
            title: title,
            type: type,
            description: React.createElement(Suspense, {
              fallback: React.createElement("div", {
                style: {
                  height: '100%'
                }
              })
            }, _this.props.device === 'mobile' && (quest === null || quest === void 0 ? void 0 : quest.newH5Style) ? React.createElement(NewEnding, {
              questName: quest.title,
              title: title,
              type: type,
              res: data,
              finishImgScale: finishImgScale,
              finishImgUrl: finishImgUrl,
              realPrompt: _this.realPrompt,
              did: did,
              uid: uid,
              device: _this.props.device,
              showLotteryPage: _this.showLotteryPage
            }) : React.createElement(Ending, {
              title: title,
              type: type,
              res: data,
              finishImgScale: finishImgScale,
              finishImgUrl: finishImgUrl,
              realPrompt: _this.realPrompt,
              did: did,
              uid: uid,
              device: _this.props.device,
              showLotteryPage: _this.showLotteryPage
            }))
          }
        });
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showQuotaLimit", function (hit, quotaStrategy) {
      var _filteredAnswers$qid;
      var _this$state4 = _this.state,
        answers = _this$state4.answers,
        quest = _this$state4.quest;
      var filteredAnswers = _objectSpread({}, answers);
      var qid = hit.question_id;
      filteredAnswers[qid].selected = (_filteredAnswers$qid = filteredAnswers[qid]) === null || _filteredAnswers$qid === void 0 ? void 0 : _filteredAnswers$qid.selected.filter(function (id) {
        return hit.option_id !== id;
      });
      var that = _assertThisInitialized(_assertThisInitialized(_this));
      _this.setState({
        answers: filteredAnswers
      }, function () {
        that.setState({
          quest: _objectSpread({}, quest, {
            quotaStrategy: CaseUtil.toCaml(quotaStrategy)
          })
        }, that.forceUpdate);
      });
      var element = document.getElementById(qid);
      // element.setAttribute('style', 'border: 1px solid red !important');
      element.scrollIntoView();
      document.querySelector('body').scrollTop = element.offsetTop;
      document.querySelector('html').scrollTop = element.offsetTop;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "turnPage", function () {
      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        current: 1,
        total: 1
      };
      _this.setState(function (_ref3) {
        var page = _ref3.page;
        return getPage({
          p: p,
          page: page
        });
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSubmit", function (value) {
      var _this$state$page = _this.state.page,
        current = _this$state$page.current,
        total = _this$state$page.total;
      _this.setState(function (_ref4) {
        var showAnswer = _ref4.showAnswer;
        return {
          showAnswer: _objectSpread({}, showAnswer, value)
        };
      });
      // validator form
      if (current < total) {
        _this.turnPage({
          current: current + 1
        });
        scrollToTop();
        return null;
      }
      return _this.submitForm();
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "emptyAllAnswers", function () {
      _this.setState({
        answers: {}
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "update", function (changed) {
      if (_this.submitting) return;
      _this.submitted = false;
      _this.setState(function (_ref5) {
        var answers = _ref5.answers;
        return {
          answers: _objectSpread({}, answers, changed)
        };
      }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$state5, answers, page, sampleConfig, selectedAnswers, stringToEncrypt, cipher, answerKeys, questions, hasChoice, _questionFilter2, _questionFilter2$visi, visibles, isNextEnd, globalSampleGids, qs;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$state5 = _this.state, answers = _this$state5.answers, page = _this$state5.page, sampleConfig = _this$state5.sampleConfig;
                selectedAnswers = _this.getSelectedAnswers(answers);
                Object.keys(changed).forEach(function (id) {
                  return _this.traceUpdate(id, selectedAnswers);
                });
                stringToEncrypt = JSON.stringify(answers);
                if (isUrlToGenStamp) {
                  cipher = AES.encrypt(stringToEncrypt, _this.questId).toString();
                  _this.setState({
                    cipherUrl: "".concat(window.location.href.split('#/')[0].replace('/q/', '/b/'), "#/").concat(cipher)
                  });
                }
                answerKeys = Object.keys(changed);
                questions = _this.state.allQuestions;
                hasChoice = answerKeys.some(function (id) {
                  var question = questions.find(function (q) {
                    return q.id === id;
                  });
                  return typeChecker.isChoice(question) || typeChecker.isScale(question) || typeChecker.isMatrix(question);
                });
                if (hasChoice) {
                  // 如果是选择题变化了，那依赖可能变了，理论上只需要更新该题以后的题目即可
                  _questionFilter2 = questionFilter(questions, answers, sampleConfig, answerKeys), _questionFilter2$visi = _questionFilter2.visibles, visibles = _questionFilter2$visi === void 0 ? [] : _questionFilter2$visi, isNextEnd = _questionFilter2.isNextEnd, globalSampleGids = _questionFilter2.globalSampleGids;
                  qs = visibles;
                  if (Object.keys(globalSampleGids).length && shuffleGroup({
                    sampleConfig: sampleConfig
                  })) {
                    qs = getRealQuestions({
                      globalSampleGids: globalSampleGids,
                      questions: qs
                    });
                  }
                  _this.setState({
                    questions: qs,
                    page: _objectSpread({}, page, {
                      total: qs.filter(function (el, index) {
                        return el.type === 'page_break' && index !== qs.length - 1;
                      }).length
                    }),
                    isNextEnd: isNextEnd
                  });
                }
              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      })));
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPageContent", function () {
      // questions 是实际展示的题目list
      var _this$state6 = _this.state,
        questions = _this$state6.questions,
        current = _this$state6.page.current,
        isNextEnd = _this$state6.isNextEnd;
      return getPageContentLogic(questions, current, isNextEnd);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "backLastPage", function () {
      var current = _this.state.page.current;
      if (current > 0) {
        _this.turnPage({
          current: current - 1
        });
        scrollToTop();
        return null;
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setUpStore", function () {
      return {
        state: _objectSpread({}, _this.state, {
          realPrompt: _this.realPrompt
        }),
        action: {
          submit: _this.onSubmit,
          emptyAllAnswers: _this.emptyAllAnswers,
          turnPage: _this.turnPage,
          update: _this.update,
          getPageContent: _this.getPageContent,
          backLastPage: _this.backLastPage
        }
      };
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showLotteryPage", function () {
      _this.setState({
        showLottery: true
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getSelectedAnswers", function (answers) {
      var location = _this.props.location;
      var questions = _this.state.questions;
      var params = {};
      Object.keys(answers).forEach(function (key) {
        try {
          var hasSelectd = _this.checkQuestSeleted(answers, key);
          if (hasSelectd) {
            params[key] = answers[key];
            questions.forEach(function (q) {
              if (q.id === key) {
                params[key].uuid = q.uuid;
              }
            });
          }
        } catch (err) {
          console.error(err);
        }
      });
      params.custom_answer = getUrlParams(location);
      return params;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkQuestSeleted", function (answers, key) {
      var type = answers[key].type;
      if (type === 'matrix') {
        var _answers$key;
        return Object.keys(((_answers$key = answers[key]) === null || _answers$key === void 0 ? void 0 : _answers$key.selected) || {}).length;
      } else if (type === 'optionInput') {
        var _answers$key2;
        var selected = (_answers$key2 = answers[key]) === null || _answers$key2 === void 0 ? void 0 : _answers$key2.option_blank;
        if (Object.keys(selected || {}).length) {
          for (var k in selected) {
            var _selected$k;
            return ((_selected$k = selected[k]) === null || _selected$k === void 0 ? void 0 : _selected$k.length) > 0 && selected[k][0] !== '';
          }
        }
      } else if (type === 'cascader') {
        var _answers$key3, _answers$key3$selecte;
        return (_answers$key3 = answers[key]) === null || _answers$key3 === void 0 ? void 0 : (_answers$key3$selecte = _answers$key3.selected_ids) === null || _answers$key3$selecte === void 0 ? void 0 : _answers$key3$selecte.length;
      } else if (['short', 'long'].includes(type)) {
        var _answers$key4;
        return (_answers$key4 = answers[key]) === null || _answers$key4 === void 0 ? void 0 : _answers$key4.text;
      } else if (type === 'scale') {
        var _answers$key5;
        return (_answers$key5 = answers[key]) === null || _answers$key5 === void 0 ? void 0 : _answers$key5.degree;
      } else if (type === 'location') {
        var _answers$key6, _answers$key6$locatio;
        return (_answers$key6 = answers[key]) === null || _answers$key6 === void 0 ? void 0 : (_answers$key6$locatio = _answers$key6.location) === null || _answers$key6$locatio === void 0 ? void 0 : _answers$key6$locatio.length;
      } else if (type === 'date') {
        var _answers$key7;
        return (_answers$key7 = answers[key]) === null || _answers$key7 === void 0 ? void 0 : _answers$key7.date;
      } else if (type === 'upload') {
        var _answers$key8, _answers$key8$list;
        return (_answers$key8 = answers[key]) === null || _answers$key8 === void 0 ? void 0 : (_answers$key8$list = _answers$key8.list) === null || _answers$key8$list === void 0 ? void 0 : _answers$key8$list.length;
      } else {
        var _answers$key9, _answers$key9$selecte;
        return (_answers$key9 = answers[key]) === null || _answers$key9 === void 0 ? void 0 : (_answers$key9$selecte = _answers$key9.selected) === null || _answers$key9$selecte === void 0 ? void 0 : _answers$key9$selecte.length;
      }
    });
    window.isRD = window.location.host.includes('127.0.0.1');
    window.isLocal = /preview\/?$/.test(window.location.pathname);
    window.isReport = /dp_survey_statistics|bytesurvey_responses/.test(window.location.href);
    var _hashId = _this.getQuestId();
    _this.state = {
      id: _hashId,
      loading: true,
      msg: null,
      // 不要使用message这个关键字，可能会被antd import给误认为是message组件
      page: {
        current: 1,
        total: 1
      },
      quest: null,
      questions: [],
      recycleUid: true,
      // 回收uid
      recycleProducts: null,
      // 回收app list
      resume: true,
      // 断点续答
      allQuestions: [],
      answers: {},
      startTime: null,
      // 开始答题时间戳 秒
      showAnswer: {},
      cipherUrl: '',
      error: '',
      showLottery: false,
      sampleConfig: null,
      previewAuth: true,
      qnVersion: null
    };
    return _this;
  }
  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      try {
        localStorage.setItem('survey-height', document.body.clientHeight);
        localStorage.setItem('survey-width', document.body.clientWidth);
      } catch (error) {
        console.error('get LSAnswer error: ', error.message);
      }
      var urlParams = getUrlParams(this.props.location);
      if (!window.isLocal || urlParams.id) {
        this.fetchQuest();
      }
      if (window.isLocal) {
        console.log('Under development environment, TEA data uploading is disabled.');
        if (urlParams.id && urlParams.timestamp) {
          localStorage.removeItem("survey-preview-".concat(urlParams.id));
        }
        this.getLocalQuest();
      }
      if (urlParams.appId && urlParams.appId === '2682' && this.props.device === 'mobile') {
        document.addEventListener('contextmenu', function (e) {
          e.preventDefault();
        });
      }
      this.setState({
        startTime: Date.now()
      });
      // console.log('SLARDAR_RELEASE', process.env.SLARDAR_RELEASE);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      var answers = this.state.answers;
      if (prevState.answers !== answers) {
        var _this$state7 = this.state,
          questionnaireId = _this$state7.id,
          resume = _this$state7.resume;
        if (!window.isLocal && (!questionnaireId || !resume)) return;
        var urlParams = getUrlParams();
        var localStorageId = window.isLocal && !(urlParams.uid || urlParams.uindex) ? "survey-preview-".concat(urlParams.id) : questionnaireId;
        try {
          var LSAnswer = localStorageId ? localStorage.getItem(localStorageId) || '{}' : '{}';
          LSAnswer = JSON.parse(LSAnswer);
          Object.entries(answers).forEach(function (_ref7) {
            var _ref8 = _slicedToArray(_ref7, 2),
              key = _ref8[0],
              value = _ref8[1];
            LSAnswer[key] = value;
          });
          if (localStorageId) {
            localStorage.setItem(localStorageId, JSON.stringify(LSAnswer));
          }
        } catch (error) {
          console.error('get LSAnswer error: ', error.message);
        }
      }
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      // 你同样可以将错误日志上报给服务器
      var stack = JSON.parse(JSON.stringify(errorInfo)).componentStack.split('\n').toString();
      console.error('mainError', error.message);
      traceOnError(error.message, error.code, stack);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      traceExitQuestionnaire(true);
      this.setState({
        startTime: null
      });
    }
  }, {
    key: "getLocalQuest",
    value: function getLocalQuest() {
      var _this2 = this;
      console.debug('getLocalQuest');
      // 监听用户单份答案
      window.addEventListener('message', function (evt) {
        var data = evt.data;
        if (!data.qid) return;
        if (data.type === 'user-report-answers') {
          document.querySelector('#root').style.pointerEvents = 'none';
          var answers = JSON.parse(data.answers);
          _this2.setState(function (_ref9) {
            var quest = _ref9.quest;
            return {
              quest: _objectSpread({}, quest, {
                desc: ''
              })
            };
          });
          _this2.update(answers);
        } else if (data.type === 'user-report-print') {
          window.print();
        }
      });
    }
  }, {
    key: "fetchQuest",
    value: function () {
      var _fetchQuest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this3 = this;
        var hashId, _this$props, location, _this$props$device, device, customsPre, urlCustoms;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                hashId = this.getQuestId();
                if (!(!hashId && !window.isLocal)) {
                  _context4.next = 6;
                  break;
                }
                this.setState({
                  loading: false,
                  msg: {
                    type: 'error',
                    title: getLocalText('no.id')
                  }
                });
                postMessage({
                  type: 'error-mount',
                  code: 0,
                  message: '找不到问卷ID'
                });
                postMessage({
                  type: 'did-mount'
                });
                return _context4.abrupt("return");
              case 6:
                this.setState({
                  loading: true
                });
                _this$props = this.props, location = _this$props.location, _this$props$device = _this$props.device, device = _this$props$device === void 0 ? 'pc' : _this$props$device;
                customsPre = getUrlParams(location);
                urlCustoms = Object.keys(customsPre).map(function (key) {
                  return "".concat(key, "=").concat(customsPre[key]);
                }).join('&');
                api.getQuest(hashId, this.questId, this.sign, urlCustoms).then(function (res) {
                  if (!_this3.state.startTime) {
                    return;
                  }
                  if (res === 'noPreviewAuth') {
                    _this3.setState({
                      loading: false,
                      previewAuth: false
                    });
                    return;
                  }
                  window.serverTime = res.server_time;
                  window.rnd = res.rnd;
                  var sampleQuestInfo = sampleDataToQuestions(res.data);
                  var questionnaire = CaseUtil.toCaml(sampleQuestInfo);
                  _this3.setState({
                    loading: false,
                    sampleConfig: questionnaire.struct.sampleConfig,
                    qnVersion: questionnaire.qnVersion
                  },
                  // 问卷访问正常
                  function () {
                    return postMessage({
                      type: 'success-mount',
                      data: CaseUtil.toCaml(sampleQuestInfo)
                    });
                  });
                  var quest = transferDefaultDataToQuest(questionnaire);
                  if (!window.isLocal && !window.isReport) {
                    var _quest$resume;
                    _this3.retrieveDefaultAnswers((_quest$resume = quest.resume) !== null && _quest$resume !== void 0 ? _quest$resume : true);
                  }
                  if (quest.prompt) {
                    _this3.realPrompt = quest.prompt;
                  }
                  // FIXME: 中转页面跳转0.1s
                  if (window.location.href.includes('?survey_finish_immediately')) {
                    handleLimitTime(_this3.submitForm, 0);
                  } else if (quest.limitTime) {
                    handleLimitTime(_this3.submitForm, quest.limitTime * 60);
                  }
                  _this3.resetStore(hashId, quest);
                  window.showErrorInfoAfterSubmitBtn = showErrorQuestIds.includes(questionnaire.questionnaireId);
                }).catch(function (err) {
                  if (!_this3.state.startTime) {
                    return;
                  }
                  if (err.code == 401) {
                    return;
                  } else if (err && err.code >= 400 && err.code < 600) {
                    var _err$data;
                    window.language = err.language || navigatorLang();
                    traceOnError(err.message, err.code, '问卷详情接口');
                    var errorText = err.i18n_prompt ? getLocalText("error.".concat(err.i18n_prompt)) // 后端错误提示
                    : getLocalText('RequestError.400');
                    var fixedScore = (_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.score;
                    if (err.data && fixedScore !== undefined) {
                      if (fixedScore !== Math.round(fixedScore)) {
                        fixedScore = fixedScore.toFixed(2);
                      }
                      errorText = React.createElement(React.Fragment, null, React.createElement("div", {
                        className: "flex alignCenter justifyCenter"
                      }, errorText), React.createElement("div", {
                        className: "flex alignCenter justifyCenter"
                      }, getLocalText('user-score'), React.createElement("div", {
                        className: "score"
                      }, fixedScore)));
                    }
                    _this3.setState({
                      msg: {
                        title: errorText,
                        type: 'warning',
                        description: React.createElement(Suspense, {
                          fallback: React.createElement("div", {
                            style: {
                              height: '100%'
                            }
                          })
                        }, React.createElement(Ending, {
                          type: "warning",
                          title: errorText,
                          res: err.data || {},
                          errorCode: err.i18n_prompt,
                          realPrompt: (err.data || {}).prompt,
                          showLotteryPage: _this3.showLotteryPage,
                          device: _this3.props.device
                        }))
                      },
                      loading: false
                    });
                    console.warn('catch', err);
                  } else {
                    _this3.props.throwError(err);
                  }
                  _this3.setState(function (state) {
                    return _objectSpread({}, state, {
                      loading: false
                    });
                  }, function () {
                    // 问卷失效，过期等异常情况
                    postMessage({
                      type: 'error-mount',
                      code: err.code || 0,
                      message: err.message
                    });
                  });
                }).finally(function () {
                  return postMessage({
                    type: 'did-mount'
                  });
                });
              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      return function fetchQuest() {
        return _fetchQuest.apply(this, arguments);
      };
    }()
  }, {
    key: "render",
    value: function render() {
      var _background$color;
      var _this$props2 = this.props,
        videoStyle = _this$props2.videoStyle,
        _this$props2$device = _this$props2.device,
        device = _this$props2$device === void 0 ? 'pc' : _this$props2$device;
      var _this$state8 = this.state,
        quest = _this$state8.quest,
        answers = _this$state8.answers,
        questions = _this$state8.questions,
        previewAuth = _this$state8.previewAuth;
      var store = this.setUpStore();
      var theme = (quest === null || quest === void 0 ? void 0 : quest.theme) || '';
      var newH5Style = device === 'mobile' && (quest === null || quest === void 0 ? void 0 : quest.newH5Style);
      var questBgColor = (quest === null || quest === void 0 ? void 0 : quest.questBackground) || '#fff';
      var background = (quest === null || quest === void 0 ? void 0 : quest.background) || {};
      var customizedTheme = themesRepo[theme];
      var primaryColor = (quest === null || quest === void 0 ? void 0 : quest.primaryColor) || '#3370ff';
      var textColor = background.type === 'color' && (quest === null || quest === void 0 ? void 0 : quest.textColor) || '';
      var pageBgColor = (_background$color = background.color) !== null && _background$color !== void 0 ? _background$color : 'var(--bg-gray)';
      Window.prototype.setItem('survey-quest-theme', theme);
      var titleKey = window.showMultiLang ? "".concat(window.language, "Title") : 'title';
      return React.createElement(React.Fragment, null, React.createElement(Helmet, null, React.createElement("title", null, (quest === null || quest === void 0 ? void 0 : quest[titleKey]) || 'Survey'), React.createElement("meta", {
        name: "title",
        content: (quest === null || quest === void 0 ? void 0 : quest[titleKey]) || 'Powered by ByteSurvey'
      })), React.createElement(Global, {
        styles:
        /*#__PURE__*/
        /*#__PURE__*/
        css(newH5Style ? getNewH5HTML : customizedTheme ? getCustomizedHTML(customizedTheme) : background.type === 'url' && background.url && device == 'mobile' ? getCustomizedHTMLByQuestBgColor(quest, questBgColor) : "\n            html {\n              --primary-color: ".concat(primaryColor, " !important;\n              --text-color: ").concat(textColor, " !important;\n              --page-bg: ").concat(pageBgColor, " !important;\n            }"))
      }), React.createElement(GlbStyleBox, {
        id: "app",
        style: _objectSpread({}, window.textDirection),
        className: /*#__PURE__*/_css(_ref10, videoStyle, _ref11)
      }, (quest === null || quest === void 0 ? void 0 : quest.showProgress) && window.location.href.indexOf('/submitted') < 0 && React.createElement(Suspense, {
        fallback: React.createElement("div", {
          style: {
            height: 6
          }
        })
      }, React.createElement(Progress, {
        newH5Style: quest.newH5Style,
        progress: Object.keys(answers).filter(function (qid) {
          return questions.find(function (q) {
            return q.id === qid;
          });
        }).length / questions.filter(function (q) {
          return !typeChecker.isPageBreak(q) && !typeChecker.isDescription(q);
        }).length * 100
      })), React.createElement(LimitTime, null, quest && !!quest.limitTime && React.createElement(IconFont, {
        type: "icon-clock",
        className: "marginRight5"
      }), React.createElement("div", {
        id: "limitTimeRef"
      })), React.createElement(Provider, {
        value: store
      }, (!!this.state.questions.length || !!this.state.msg || !this.state.loading) && this.props.children)), !previewAuth && React.createElement("div", {
        style: {
          textAlign: 'center',
          paddingTop: 120
        }
      }, "\u65E0\u9884\u89C8\u6743\u9650-No Auth"));
    }
  }]);
  return App;
}(PureComponent)) || _class) || _class;
export default module.hot ? hot(module)(App) : App;
var LimitTime = /*#__PURE__*/styled("div", {
  target: "e4emdwb0"
})("position:fixed;z-index:999;top:10px;right:10px;display:flex;align-items:center;");